<template>
  <nav class="top-menu-standard-dashboard">
    <div>
      <div class="menu-logo">
        <a href>
          <FollowUPLogotype />
        </a>
      </div>

      <div class="menu-icon">
        <a :class="{open: isExpanded}" @click="expandMenu" id="expand-icon">
          <div class="line"></div>
          <div class="line"></div>
          <div class="line"></div>
        </a>
    </div>

      <ul :class="{ expanded: this.isExpanded }">
        <li>
          <a href>STRONA GŁÓWNA</a>
        </li>
        <li>
          <a href>CENNIK</a>
        </li>
        <li>
          <a href>KONTAKT</a>
        </li>
        <transition name="auth-fade">
          <li v-if="isLoggedIn">
            <button class="btn-center" @click="logout">WYLOGUJ</button>
          </li>
        </transition>
      </ul>
    </div>
  </nav>
</template>

<script>
import FollowUPLogotype from "@/components/svgs/FollowUPLogotype.vue";

export default {
  name: "TopMenu",
  components: {
    FollowUPLogotype
  },
  data() {
    return {
      isExpanded: false
    };
  },
  methods: {
    expandMenu() {
      this.isExpanded = !this.isExpanded;
    },
    logout() {
      this.$store.dispatch("logout");
      this.expandMenu();
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  }
};
</script>

<style lang="scss" scoped>
.top-menu-standard-dashboard {
  z-index: 100;
  position: fixed;
  top: 0;
  color: rgba(255, 255, 255, 1);
  padding: 10px;
  background: #212121;
  width: 100%;
  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    margin: 0 auto;

    > .menu-logo {
      flex-grow: 1;
      display: flex;
      align-items: center;
      padding: 0 10px;
    }

    // Menu Icon when < laptop
    > .menu-icon {
      // Hide by default
      display: none;
      padding-top: 5px;
      margin-right: 20px;
      cursor: pointer;

      .line {
        height: 3px;
        width: 25px;
        margin: 5px 0;
        background-color: #fff;
      }

      > a {
        transition: padding 0.7s ease, transform 0.7s ease, color 0.7s ease;
        font-size: 36px;
        color: #fff;
        display: inline-block;

        &:hover {
          color: rgb(108, 232, 219);
          transform-origin: 50% 50%;
        }

        & div {
          transition: transform 0.5s, opacity 0.5s;
        }

        &.open div {

          &:first-child {
            transform: translateY(8px) rotate(-45deg);
          }

          &:nth-child(2) {
            opacity: 0;
          }

          &:last-child {
            transform: translateY(-8px) rotate(45deg);
          }
        }
      }
      @media (max-width: 1024px) {
        display: block;
      }
    }

    > ul {
      transition: left 0.7s ease, opacity 0.7s ease;
      list-style: outside none none;
      padding: 0;
      margin: 0;
      margin-right: 24px;
      li {
        display: inline-block;
      }
      li {
        line-height: normal;
        > a {
          text-decoration: none;
          transition: padding 0.7s ease, color 0.7s ease;
          font-size: 32px;
          font-weight: lighter;
          padding: 10px 24px;
          display: list-item;
          color: #fff;
          &:focus,
          &:hover {
            color: rgb(86, 204, 192);
          }
        }
      }

      // When menu is below laptop
      @media (max-width: 1024px) {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        padding-top: 128px;
        z-index: -1;
        background: rgb(38, 38, 38);
        min-width: 100%;
        left: -100%;
      }

      > li {
        display: list-item;
        float: left;

        > a {
          transition: padding 0.7s ease, font-size 0.7s ease, color 0.7s ease;
          font-size: 16px;
          padding: 10px;
        }

        @media (max-width: 1024px) {
          float: none;
          text-align: center;
        }
      }

      &.expanded {
        @media (max-width: 1024px) {
          left: 0;
        }
      }
    }
  }

  @media (max-width: 1024px) {
    &.reduced {
      > div > ul > li > a {
        font-size: 21px;
        padding: 24px;
      }
    }
  }
}

button {
  padding: 3px 15px;
  margin: 0 5px;
  color: #fff;
  height: 39px;
  font-size: 16px;
  background: #333;
  &:hover {
    background: #fff;
    color: #212121;
  }
}
</style>
